import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {getHistorySouscriptionsSaga} from "./historiqueSouscriptionSaga";

export default function* historySouscriptionsWatcher() {
  yield takeLatest(
    ActionsTypes.GET_HISTORY_SOUSCRIPTIONS,
    getHistorySouscriptionsSaga
  );
}
